import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import store from '@/store';

// ele-admin 自带多语言
import enLocale from 'ele-admin/packages/lang/en';
import arLocale from 'ele-admin/packages/lang/ar';
import zhLocale from 'ele-admin/packages/lang/zh-CN';
import csLocale from 'ele-admin/packages/lang/cs-CZ';
import itLocale from 'ele-admin/packages/lang/it';
import slLocale from 'ele-admin/packages/lang/sl';
import hrLocale from 'ele-admin/packages/lang/hr';
import bgLocale from 'ele-admin/packages/lang/bg';
import hyLocale from 'ele-admin/packages/lang/hy-AM';

Vue.use(VueI18n);

// 自动加载 src/lang 下的语言文件
const files = require.context('./', false, /\.js$/);
const customMessages = {};
files.keys().forEach((key) => {
  if (key === './index.js') return; // 跳过自己
  const langCode = key.replace('./', '').replace('.js', '');
  customMessages[langCode] = files(key).default;
});

// 配置 ele-admin 的 locale 文件（如果有新的语言，手动扩展这块）
const eleLocales = {
  en: enLocale,
  ar: arLocale,
  zh: zhLocale,
  cs: csLocale,
  it: itLocale,
  sl: slLocale, // 斯洛文尼亚语
  hr: hrLocale, // 克罗地亚语
  bg: bgLocale, // 保加利亚语
  hy: hyLocale // 亚美尼亚语
  // sl: itLocale, // 例如 sl 暂时复用 itLocale
};

const messages = {};
Object.keys(customMessages).forEach((lang) => {
  messages[lang] = {
    ...customMessages[lang],
    ...(eleLocales[lang] || {})
  };
});

const getDefaultLang = () => {
  const envLang = process.env.VUE_APP_THEME === 'hippo' ? 'en' : 'zh';
  const localLang = localStorage.getItem('hippoLang');
  let result = localLang || envLang;

  // 限定在已加载的语言范围内
  if (!messages[result]) {
    result = 'en';
  }

  localStorage.setItem('hippoLang', result);
  store.commit('SET_LANGUAGE', result);
  return result;
};

const i18n = new VueI18n({
  locale: getDefaultLang(),
  messages,
  silentTranslationWarn: true
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;
